<template>
    <div class="mob">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'mob',
    data() {
        return {}
    },
    mounted() {},
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.mob {
}
</style>
